import '@/i18n/template/projects/merchant/store/modules/notification.js'
import Vue from 'vue'
import { Notification } from 'element-ui'
import router from '../../router'
import i18n from '@/i18n'
import { WebSocket_URL } from '@/config'
import sockjs from '@/lib/sockjs/index'
import { speechNumber } from '../../components/NumberToSpeech'
import dayjs from 'dayjs'
import { downloadFile } from '@/util'
import { emitEvent, EventTypes } from '@/util/event'

let playQueue = null

// 是在静音时间段内
export function isMuteTimeRange() {
  const voiceEnabled = localStorage.getItem('voiceEnabled') === '1'
  const disturbEnabled = localStorage.getItem('disturbEnabled') === '1'
  let disturbRepeat = localStorage.getItem('disturbRepeat') || ''
  let disturbStart = localStorage.getItem('disturbStart') || ''
  let disturbEnd = localStorage.getItem('disturbEnd') || ''
  // 功能关闭 则算作静音
  if (!voiceEnabled) {
    return true
  }
  if (disturbEnabled) {
    let now = dayjs()
    let day = now.day()
    if (day === 0) {
      day = 7
    }
    if (disturbRepeat.indexOf(day + '') === -1) {
      return false
    }
    let [startH, startM] = disturbStart.split(':')
    let [endH, endM] = disturbEnd.split(':')
    let sT = dayjs().startOf('day').add(startH, 'hour').add(startM, 'minute')
    let eT = dayjs().startOf('day').add(endH, 'hour').add(endM, 'minute')
    if (eT.isBefore(sT)) {
      eT = eT.add(1, 'day')
    }
    if (now.isAfter(sT) && now.isBefore(eT)) {
      return true
    }
  }
  return false
}

export function onVoiceRemindNotificationEvent(data) {
  if (!playQueue) {
    playQueue = new Promise(resolve => resolve())
  }
  playQueue = playQueue.finally(async () => {
    if (isMuteTimeRange()) {
      return
    }
    return speechNumber(data.amount)
  })
}

function onTrustyReceived(msg) {
  onVoiceRemindNotificationEvent({ amount: msg.amount })
  const vcomp = new Vue({})
  const h = vcomp.$createElement
  let notify = null
  notify = Notification({
    title: i18n.t('VoiceReminder'),
    type: 'success',
    duration: 10000,
    message: h(
      'div',
      {
        style: {
          cursor: 'pointer',
          textAlign: 'left',
          whiteSpace: 'pre-line'
        }
      },
      [
        'Trusty Received :' + vcomp.$filters.money(msg.amount),
        h(
          'span',
          {
            style: {
              color: '#4D03D4',
              fontSize: '14px',
              paddingLeft: '10px'
            }
          },
          i18n.t('Detail') + '>'
        )
      ]
    ),
    onClick: () => {
      notify.close()
      router.push({
        name: 'account_history',
        query: { t: Date.now() }
      })
    }
  })
}

export default {
  namespaced: true,
  state: {},
  actions: {
    async startSockJs(context, sessionId) {
      const auth = context.rootState.user.userInfo?.custId
      if (sessionId) {
        if (!auth) {
          emitEvent('SeatSocketStatus', {
            connected: false,
            sessionId,
            error: 'Missing auth'
          })
          return false
        }
        await sockjs.init()
        let statusEmitted = false
        try {
          const connected = await sockjs.startConnet({
            url: WebSocket_URL,
            auth,
            path: `/user/ticket/session/${sessionId}/msg`,
            timeoutMs: 15000,
            disconnectOnTimeout: false,
            onConnect: () => {
              statusEmitted = true
              emitEvent('SeatSocketStatus', { connected: true, sessionId })
            },
            onError: err => {
              statusEmitted = true
              emitEvent('SeatSocketStatus', {
                connected: false,
                sessionId,
                err
              })
            },
            onResponse: msg => {
              emitEvent(EventTypes.RefreshSeat, msg)
            }
          })
          if (!connected && !statusEmitted) {
            emitEvent('SeatSocketStatus', { connected: false, sessionId })
          }
          return !!connected
        } catch (err) {
          if (!statusEmitted) {
            emitEvent('SeatSocketStatus', { connected: false, sessionId, err })
          }
          return false
        }
      }
      await sockjs.init()
      sockjs.startConnet({
        url: WebSocket_URL,
        auth,
        path: `/user/mportal/${auth}/msg`,
        onResponse: msg => {
          console.log('onReceiveMessage', msg)
          context.dispatch('addNotfication', msg)
        }
      })
      return true
    },
    stopSockJs() {
      sockjs.disconnect()
    },
    addNotfication(context, msg) {
      console.log('addNotfication', msg)
      if (msg.type === 'export_result') {
        const vcomp = new Vue({})
        const h = vcomp.$createElement
        let notifyType = msg.taskSts == '2' ? 'success' : 'error'
        let contentText =
          msg.busTpNm + ' Export ' + (msg.taskSts == '2' ? 'Success' : 'Failed')
        let notify = Notification({
          title: '',
          type: notifyType,
          duration: 0,
          showClose: true,
          message: h(
            'div',
            {
              style: {
                cursor: 'pointer',
                textAlign: 'left',
                whiteSpace: 'pre-line'
              }
            },
            [
              contentText,
              msg.taskSts == '2' &&
                h(
                  'span',
                  {
                    style: {
                      color: '#4D03D4',
                      fontSize: '14px',
                      paddingLeft: '10px'
                    }
                  },
                  i18n.t('Export') + '>'
                )
            ]
          ),
          onClick: () => {
            notify.close()
            if (msg.taskSts == '2') {
              downloadFile(msg.signUrl)
            }
          }
        })
        return
      }
      if (msg.amount && msg.status == 'Y') {
        onTrustyReceived(msg)
      }
    }
  }
}
